import PreviewPicture from './PreviewPicture.vue';
export default PreviewPicture;